

















import { Component, Vue, Prop } from 'vue-property-decorator'
import NavigationDrawer from '@/components/template/NavigationDrawer.vue'
import Toolbar from '@/components/template/Toolbar.vue'
import Footer from '@/components/template/Footer.vue'
import DialogWrapper from '@/components/template/DialogWrapper.vue'

@Component({
  components: {NavigationDrawer, Toolbar, Footer, DialogWrapper}
})
export default class Template extends Vue {

}
